import "./experienceCard.css";

export default function ExperienceCard({
    title,
    company,
    location,
    period,
    points = [],
    side = "left",
    }) {
    return (
        <div className={`experience-item experience-item--${side}`}>
        <div className="experience-dot" />

        <article className="experience-card">
        <div className="experience-card-header">
            <div>
            <h3>{title}</h3>

            <p className="experience-company">
                {company}
                {location && <span> | {location}</span>}
            </p>
            </div>

            <span className="experience-period">{period}</span>
        </div>

        {points.length > 0 && (
            <ul className="experience-points">
            {points.map((point, index) => (
                <li key={index}>{point}</li>
            ))}
            </ul>
        )}
        </article>
        </div>
    );
}